/**
 * Инициалы: первые буквы двух первых слов. «Давид Монарес» → «ДМ»,
 * одно слово → одна буква, пустая строка → «?».
 */
export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);

  if (parts.length === 0) {
    return '?';
  }

  return parts
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join('');
}
